const config = {
  firebase: {
    config: {
      apiKey: 'AIzaSyDqrxz_LuE44Q6w75Co43d-bDGPqOmxFOI',
      authDomain: 'emetworks-fds-34206.firebaseapp.com',
      databaseURL: 'https://emetworks-fds-34206.firebaseio.com',
      projectId: 'emetworks-fds-34206',
      storageBucket: 'emetworks-fds-34206.appspot.com',
      messagingSenderId: '106010554649',
      appId: '1:106010554649:web:877c94877150172a',
      measurementId: 'G-E9L2DFXXGR',
    },
    messaging: {
      publicKey: 'BKPJwkh-A12Q4mv5KxB_XhaR_RHfYMpTWIH7J4h-UnDxBjcxmpPtjPKqDxjC-ofpsVs8j3yAE4RnKBrQusN21xM',
    },
    status: false,
  },
  api: {
    // url: 'https://apibangpra.airpresense.tech',
    url: 'https://bangpra-apigateway.airpresense.tech',
    url_auth: 'https://bangpra-apigateway.airpresense.tech',
    url_socket: 'https://bangpra-notification.airpresense.tech',
    version: 'v3/api',
  },
  protocol: 'https',
  vconsole: {
    enabled: false,
  },
  style: {
    useHN: true,
  },
  mapHiding: [],
  groupNotification: true,
  cache: true,
  configType: true,
  battery: {
    hideBatteryAfter: 1440,
  },
  displayPlaceForEmergency: true,
  features: {
    report: {
      vitalSign: false,
      garmin: false,
    },
    dashboard: {
      roomName: true,
    },
    allPatients: {
      syncNirun: false,
    },
    auth: {
      authMode: 'cognito', //cognito,local
    },
  },
  headerView: {
    default: 'Pre-Sense System',
    bangpra: 'bangpra',
    phyathai: 'โรงพยาบาลพญาไท 2',
  },
};
module.exports = config;
